<template>
  <MainLoader
    :visible="true"
    size="80px"
    color="blue"
    v-if="Object.keys(bookingDetails).length === 0"
  />

  <div
    class="container max-w-screen-xl pb-10 flex items-center justify-center min-h-screen"
    v-else
  >
    <div class="flex gap-4 flex-wrap mt-5">
      <div class="w-full lg:w-1/2">
        <h3>
          Thank you for your booking
          {{ bookingDetails?.travellers_info?.[0]?.given_name }}
          {{ bookingDetails?.travellers_info?.[0]?.family_name }}, we have sent
          a confirmation email to {{ bookingDetails?.email }}.
        </h3>

        <div class="mt-3 mb-4 rounded-lg border border-stone-300 shadow-sm p-2">
          <h5 class="mb-2 font-bold">Rooms</h5>
          <div class="border-t border-stone-200 py-2">
            <div class="flex justify-between">
              <span class="font-bold">{{ bookingDetails?.room_name }}</span>
              <span class="bg-emerald-700 rounded p-1 text-sm text-white"
                >{{ bookingStatusText }}</span
              >
            </div>
            <div class="flex justify-between mt-2" v-if="bookingId">
              <span class="font-bold">Booking ID</span>
              <span class="text-sm"># {{ bookingId }}</span>
            </div>
            <div class="flex justify-between mt-2">
              <span class="font-bold">Total</span>
              <span class="text-sm">AUD ${{ paymentAmount }}</span>
            </div>
          </div>
        </div>
        <div class="rounded-lg border border-stone-300 shadow-sm p-2">
          <h5 class="mb-2 border-b border-stone-200 font-bold">
            Billing contact
          </h5>
          <dl>
            <div class="py-1 grid grid-cols-3 gap-4">
              <dt class="text-sm font-medium text-gray-500">Full name:</dt>
              <dd class="col-span-2">
                {{ bookingDetails?.travellers_info?.[0]?.given_name }}
                {{ bookingDetails?.travellers_info?.[0]?.family_name }}
              </dd>
            </div>
            <div class="py-1 grid grid-cols-3 gap-4">
              <dt class="text-sm font-medium text-gray-500">Email:</dt>
              <dd class="col-span-2">
                {{ bookingDetails?.email }}
              </dd>
            </div>
            <div class="py-1 grid grid-cols-3 gap-4">
              <dt class="text-sm font-medium text-gray-500">Phone:</dt>
              <dd class="col-span-2">
                {{ bookingDetails?.mobile_number }}
              </dd>
            </div>
          </dl>
        </div>
        <button
          type="button"
          @click="backToMainView"
          class="lsp-btn mt-3 px-3 py-2 rounded text-sm font-medium text-center"
        >
          Searching for new hotels
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted,computed } from "vue";
import { useComponentChangeStore } from "../../stores/componentChange.module.js";
import { useBookingStore } from "../../stores/booking.module.js";
import MainLoader from "../../src/UI/mainLoader.vue";

const componentChangeStore = useComponentChangeStore();
const bookingStore = useBookingStore();

const bookingDetails = ref({});

onMounted(() => {
  let storedBooking = bookingStore.getConfirmBookinDetails;

  if (!storedBooking) {
    const localData = localStorage.getItem("confirmBookingDetails");
    storedBooking = localData ? JSON.parse(localData) : {};
  }

  Object.assign(bookingDetails.value, storedBooking);
});

function backToMainView() {
  componentChangeStore.changeTheComponent("mainView");
  localStorage.removeItem("confirmBookingDetails");
}

const paymentAmount = computed(() => {
  try {
    return JSON.parse(bookingDetails.value?.payment_data || '{}')?.amount || 'N/A';
  } catch (error) {
    console.error("Error parsing payment data:", error);
    return 'N/A';
  }
});

const isR2BBooking = computed(() => {
  return bookingDetails.value?.data?.type === 'R2B';
});

const bookingStatusText = computed(() => {
  if (bookingDetails.value?.status) {
    const status = bookingDetails.value.status;
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }
  if (isR2BBooking.value) {
    return 'Held';
  }
  return 'Booked';
});

const bookingId = computed(() => {
  if (bookingDetails.value?.booking_id) {
    return bookingDetails.value.booking_id;
  }
  if (bookingDetails.value?.ratehawk_order_id) {
    return bookingDetails.value.ratehawk_order_id;
  }
  return null;
});

</script>
